exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-review-container[data-v-9a5beb6c]{display:inline;margin-left:10px;text-align:left}.order-review-container .bill-range-tips[data-v-9a5beb6c]{color:#909399}.order-review-container .bill-range-tips.error[data-v-9a5beb6c]{color:#F56C6C}.order-review-dialog .el-form-item[data-v-9a5beb6c]{margin-bottom:12px}.order-review-dialog .review-tips[data-v-9a5beb6c]{color:#909399}.order-review-dialog .review-tips.error[data-v-9a5beb6c]{color:#F56C6C}.order-review-dialog .error-num[data-v-9a5beb6c]{color:#F56C6C}\n", ""]);

// exports
